export default "__VITE_ASSET__CDy3fI29__"